module.exports = __webpack_public_path__ + "static/img/3-4.86b7336.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3-4.png
// module id = /+uI
// module chunks = 1